module.exports = __webpack_public_path__ + "img/entertainment-weekly.a4d72d2f.png";